// src/components/AdSlot.js
// Ad slot — currently hidden until ad network is connected.
// To activate: set REACT_APP_ADS_ENABLED=true in environment variables
// and replace the inner content with your ad network script.
import React from "react";

const ADS_ENABLED = process.env.REACT_APP_ADS_ENABLED === "true";

const AdSlot = ({ type = "banner" }) => {
  // Hide completely when ads are not enabled
  if (!ADS_ENABLED) return null;

  return (
    <div
      className={`ad-slot ad-${type}`}
      aria-label="Advertisement"
      role="complementary"
    >
      {/* Paste your ad network script here */}
    </div>
  );
};

export default AdSlot;
